import React, {useState} from "react"
import UserSearch from "@irati/ui/src/UserSearch"
import {H2} from "@irati/ui/src/Typography"
import {Row, Col} from "react-bootstrap"
import {Select} from "@irati/ui/src/FormItem"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import {ListCustomRewardsTransactionsFilter, User} from "@irati/types"
import Spacing from "@irati/ui/src/Spacing"
import FormatMessage from "@irati/utils/lang/types/FormatMessage"
import CustomRewardsTransactions from "@irati-web/wallet/src/components/Transactions/CustomRewardsTransactions"
enum CustomRewardStatusUsage {
  USED,
  NOT_USED,
  USED_UNUSED
}

type UsageTypeOption = {
  value: CustomRewardStatusUsage
  label: string
}
const getUsageFilterOptions = (formatMessage: FormatMessage): UsageTypeOption[] => [
  {
    value: CustomRewardStatusUsage.USED_UNUSED,
    label: formatMessage({id: "admin.search.option.usedUnused"})
  },
  {
    value: CustomRewardStatusUsage.USED,
    label: formatMessage({id: "admin.search.option.used"})
  },
  {
    value: CustomRewardStatusUsage.NOT_USED,
    label: formatMessage({id: "admin.search.option.unused"})
  }
]
const getIsUsedQueryArg = (selectedOption: UsageTypeOption): boolean | null => {
  if (selectedOption.value === CustomRewardStatusUsage.USED_UNUSED) {
    return null
  }
  return selectedOption.value === CustomRewardStatusUsage.USED
}
const CustomRewardsListTransactions = () => {
  const {formatMessage} = useIntl()
  const usageFilterOptions = getUsageFilterOptions(formatMessage)
  const [receiver, setReceiver] = useState<User>()
  const [usageFilter, setUsageFilter] = useState<UsageTypeOption>(usageFilterOptions[0])
  const handleReceiverChange = (_, user: User) => {
    setReceiver(user)
  }
  const onSelectedUsageFilter = (newUsageFilter: CustomRewardStatusUsage) => {
    setUsageFilter(usageFilterOptions.find(({value}) => value === newUsageFilter))
  }
  const queryFilters: ListCustomRewardsTransactionsFilter = {
    receiverId: receiver?.uuid,
    isUsed: getIsUsedQueryArg(usageFilter)
  }
  return (
    <div>
      <H2 marginBottom={4}>
        <FormattedMessage id="admin.customRewards.heading.transactions" />
      </H2>
      <Row>
        <Col xs={6}>
          <Row>
            <UserSearch
              onChange={handleReceiverChange}
              isClearable
              value={receiver}
              flush
              hideLabel
              placeholder="platform.fields.emplyeeSearch.placeholder"
            />
          </Row>
        </Col>
        <Col xs={6}>
          <Select
            id="selectUsageFilter"
            isClearable={false}
            isSearchable={false}
            options={usageFilterOptions}
            hideLabel
            flush
            name="selectUsageFilter"
            onChange={onSelectedUsageFilter}
            value={usageFilter}
          />
        </Col>
      </Row>
      <Spacing marginTop={4}>
        <CustomRewardsTransactions filters={queryFilters} isRedeemable />
      </Spacing>
    </div>
  )
}

export default CustomRewardsListTransactions
